import React from 'react';

/**
 * Prévia do corpo de um termo em markdown leve (extraído na at-69, frente D/D7).
 *
 * 🔴 **É um SEGUNDO parser do mesmo formato, e isso é uma dívida conhecida.** O
 * motor de verdade é o do PDF, no backend (`termo.service.ts`), e nada garante
 * que os dois concordem — o próprio `termoTemplateApi.ts` comenta querer evitar
 * exatamente isso no caso dos placeholders, que passaram a vir do servidor. A
 * saída definitiva é um endpoint de prévia em HTML do próprio motor; está
 * registrada como melhoria futura em `.claude/12-bugs.md`.
 *
 * Enquanto isso: o parser sai do componente **verbatim** — a lógica é a mesma
 * linha por linha da que vivia em `ModalEditarTemplate.tsx` (l. 53-75) — e a tela
 * passa a dizer, em texto fixo, que a prévia é **aproximada** e que o documento
 * real é o da "Pré-visualização em PDF". Não é hora de "melhorar" o parser: uma
 * divergência introduzida aqui apareceria como contrato errado.
 *
 * O formato é o que o motor aceita: parágrafos separados por linha em branco e
 * `**negrito**` (`04-business-rules.md`, seção de geração por template).
 *
 * ⚠️ Arquivo `.tsx` porque devolve JSX — é o único motivo; segue sendo utilitário
 * puro, sem estado, sem rede e sem domínio.
 */

/** O que se mostra quando ainda não há texto. */
export const PREVIA_VAZIA = 'Nenhum texto inserido ainda.';

export function renderizarPrevia(corpo: string): React.ReactNode {
  if (!corpo || !corpo.trim()) {
    return <em className="tw-text-texto-desabilitado">{PREVIA_VAZIA}</em>;
  }

  const paragrafos = corpo.split(/\n\s*\n/);

  return (
    <>
      {paragrafos.map((paragrafo, indice) => {
        const partes = paragrafo.split(/(\*\*.*?\*\*)/g);

        return (
          <p key={indice} className="tw-mb-2.5 tw-mt-0 tw-leading-relaxed">
            {partes.map((parte, indiceParte) => {
              if (parte.startsWith('**') && parte.endsWith('**')) {
                return <strong key={indiceParte}>{parte.slice(2, -2)}</strong>;
              }
              return parte;
            })}
          </p>
        );
      })}
    </>
  );
}
